import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';

export const softwareUpdateStatus = (url) => {
  return fetchdata(url, { method: 'GET' })
    .then((result) => {
      console.log('softwareUpdateStatus Result:', result);
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
};
